import * as React from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 9L1 5L5 1", style: {
  fill: "none"
}, stroke: "currentColor", fill: "none", strokeWidth: 1.33, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronLeft;
